import React, { useState } from 'react';
import './form.css';
import GoogleLoginButton from "../GoogleLoginButton/GoogleLoginButton";
import FacebookLoginButton from '../FacebookLogin/FacebookLogin';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEnvelope, faApple } from '@fortawesome/free-solid-svg-icons';
import EmailLoginForm from '../emailLogin/EmailLoginForm';
import SignupForm from '../signupForm/SignupForm';

const Form = ({ onLoginSuccess }) => {
  const handleSubmit = (e) => {
    e.preventDefault();
  };
const [showEmailLogin, setShowEmailLogin] = useState(false);
const [showSignupForm, setShowSignupForm] = useState(false);


 if (showEmailLogin) {
    return <EmailLoginForm onBack={() => setShowEmailLogin(false)} onLoginSuccess={onLoginSuccess} />;
  }

  if (showSignupForm) {
    return <SignupForm onSignupSuccess={() => setShowSignupForm(false)} onBack={() => setShowSignupForm(false)} />;
  }


return (
    <form className="LoginForm updated-form" onSubmit={handleSubmit}>
      <h4 className='text-center mb-4'>Login with</h4>

      <div className="third-party-grid d-flex justify-content-center align-items-center">
        <button
          type="button"
          className="btn login-option email"
          onClick={() => setShowEmailLogin(true)}
        >
          <FontAwesomeIcon icon={faEnvelope} width={'2.25rem'} className="pe-2" />
          Email
        </button>

        {/* <GoogleLoginButton onLoginSuccess={onLoginSuccess} /> */}

        {/* <button type="button" className="btn login-option apple">
          <svg className='pe-3' xmlns="http://www.w3.org/2000/svg" width={'2.5rem'} viewBox="0 0 384 512">
            <path d="M318.7 268.7c-.2-36.7 16.4-64.4 50-84.8-18.8-26.9-47.2-41.7-84.7-44.6-35.5-2.8-74.3 20.7-88.5 20.7-15 0-49.4-19.7-76.4-19.7C63.3 141.2 4 184.8 4 273.5q0 39.3 14.4 81.2c12.8 36.7 59 126.7 107.2 125.2 25.2-.6 43-17.9 75.8-17.9 31.8 0 48.3 17.9 76.4 17.9 48.6-.7 90.4-82.5 102.6-119.3-65.2-30.7-61.7-90-61.7-91.9zm-56.6-164.2c27.3-32.4 24.8-61.9 24-72.5-24.1 1.4-52 16.4-67.9 34.9-17.5 19.8-27.8 44.3-25.6 71.9 26.1 2 49.9-11.4 69.5-34.3z"/>
          </svg> Apple
        </button>

        <FacebookLoginButton onLoginSuccess={onLoginSuccess} /> */}
      </div>

      {/* <div className="content__or-text my-3 pt-3">
        <span></span>
        <span>Or</span>
        <span></span>
      </div>

      <div className="mb-4 pb-3">
        <label className="form-label">Phone Number</label>
        <input type="text" className="form-control" placeholder="Enter phone number" />
      </div>

      <button type="submit" className="btn btn-primary w-100">Login</button> */}

      <p className="text-center mt-3 mb-0 pt-md-4">
        Don't have an account?{" "}
        <a
          className="signup-link"
          style={{ cursor: "pointer" }}
          onClick={() => setShowSignupForm(true)}
        >
          Sign Up
        </a>
      </p>
    </form>
  );

};

export default Form;
